export default "__VITE_ASSET__30e60357__"